/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import { Accordion } from 'components/Common';
import { useTranslation } from 'react-i18next';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import isMobile from 'store/app/selector/isMobile';
import styles from './UspsPremium.module.scss';

const UspsPremium = () => {
  const { t } = useTranslation();
  const isDesktop = !useSelector(isMobile);
  const usps = useSelector(getCurrentCategory)?.usps;
  if (!usps || !usps.length) {
    return null;
  }
  return (
    <div className={styles.uspsPremium}>
      <Accordion title={t('txt_product_page_why_choose_op')} titleClassName={styles.title} expanded>
        {usps.map((usp, index) => (
          <div key={`usp${index}`} className={styles.usp}>
            <div className={styles.icon}>{(usp as any).icon && <img src={(usp as any).icon} alt="" />}</div>
            <div className={styles.descriptionWrapper}>
              <OpText variant="body-medium-light">{usp.text}</OpText>
              {!isDesktop && (
                <OpText variant="body-small-light" color="neutral-70">
                  {(usp as any).description}
                </OpText>
              )}
            </div>
            {isDesktop && (
              <>
                &nbsp;
                {(usp as any).description && (
                  <OpIcon size="x-small" icon="info-outline" tooltip={(usp as any).description} />
                )}
              </>
            )}
          </div>
        ))}
      </Accordion>
    </div>
  );
};

export default UspsPremium;
